import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

import {
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Tabs,
  Tab,
  Card,
} from "react-bootstrap";

import {
  IconCalendarWeek,
  IconChevronDown,
  IconCopyCheck,
  IconEdit,
  IconMail,
  IconPhone,
  IconShare,
  IconUser,
  IconCopy,
  IconMapPin,
  IconPaperclip,
  IconChevronLeft,
  IconFileTypeDoc,
  IconChevronRight,
  IconFileTypePdf,
  IconPhoto,
  IconUserCircle,
  IconClockHour3,
  IconArrowForwardUp,
  IconRefreshDot,
  IconLink,
  IconPackageExport,
  IconTruckDelivery,
  IconChecklist,
} from "@tabler/icons-react";
import Lottie from "lottie-react";
import notfoundData from "../../../assets/not_found.json";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";
import moment from "moment";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import SuccsessMsgModal from "../../../components/SuccessMsgModal";
import RmaKOorCustomerEmailDialog from "../Email/OrderKOorCustomerEmailDialog";

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function View_DetailsRma({
  //  show,
  //  setShow,
  //  order,
  isStatusUpdate,
  onStatusUpdate,
  triggerCardHighlight,
}) {
  const statusOptions = [
    { value: "CREATED", label: "Pending", color: "#818183ff" },
    { value: "OPEN", label: "Active/Open", color: "#f1a008ff" },
    { value: "CLOSED", label: "Closed", color: "#06a159ff" },
    { value: "CANCELLED", label: "Cancelled", color: "#e72222" },
  ];

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const IMG = process.env.REACT_APP_BASE_URL_IMG;
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(statusOptions[0]);

  const [formId, setFormId] = useState(null);

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    // reset();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    ORDERID: "",
    toEmail: "",
    toName: "",
  });

  const [isCopyQuoteOpen, setIsCopyQuoteOpen] = useState({
    show: false,
    Feild: "",
    order_id: "",
    btnText: "",
    label: "",
  });

  const { isLoading: removeLoading, postData: statusChange } = usePostRequest(
    API_ENDPOINTS.RMA_STATUS,
  );

  const { isLoading: createLoading, postData: createORDER } = usePostRequest(
    API_ENDPOINTS.ORDER_CREATE,
  );

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    setShow({ isStatusUpdate: true });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    triggerCardHighlight(response?.rma_id);
    handleClose();
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during Status Change.");
  };

  const ChangeStatusHandler = (orderid, status) => {
    statusChange(
      { rma_id: orderid, rma_status: status },
      onStatusSuccess,
      onStatusError,
    );
  };

  const openModal = (Orderid, status, Old_Status) => {
    // console.log("status");
    let modalMessage = `Are you sure you want to Change Status To "${Old_Status} To ${status}"`;
    let modalTitle = "Change Status";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeStatusHandler(Orderid, status);
    };
    let action = "Change";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const [order, setOrder] = useState(null);

  const [show, setShow] = useState(false);

  // console.log("order data", order);

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("order_id");

  // console.log("rfqId from query params:", orderId);

  // console.log("Full URL:", window.location.href);
  // console.log("location.search:", window.location.search);

  const { data: fetchedOrder, postData: fetchOrder } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_RMA,
  );

  useEffect(() => {
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const rmaId =
        searchParams.get("rma_id") ||
        window.location.search.slice(1).split("&")[0];
      if (rmaId) {
        fetchOrder({ rma_id: rmaId });
      }
    }
  }, [window.location.search]);
  // useEffect(() => {
  //   if (window.location.search) {
  //     const orderId = window.location.search.slice(1);
  //     // console.log("rfqId to be used:", orderId);
  //     fetchOrder({ rma_id: orderId });
  //   }
  // }, [window.location.search]);

  useEffect(() => {
    if (fetchedOrder?.data) {
      setOrder(fetchedOrder.data); // Store fetched opportunity
      setShow(true);
    }
  }, [fetchedOrder]);

  const handleClose = () => {
    setShow(false);
    const newUrl = window.location.pathname;
    window.history.pushState(null, "", newUrl);
  };

  const ITEMS_PER_VIEW = 3.5;

  const navigate = useNavigate();

  const downloadImage = async (e, item) => {
    e.preventDefault();

    const imageUrl = `${BASE_URL}/common/download/${item?.file_name}`;
    const customFileName = item.original_name;

    try {
      const response = await fetch(imageUrl, {
        method: "GET",
      });

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", customFileName || "download.jpg");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  useEffect(() => {
    if (order?.status) {
      const match = statusOptions.find((opt) => opt.value === order.status);
      if (match) {
        setSelected(match);
      }
    }
  }, [order]);

  const handleShareClick = () => {
    const baseUrl = window.location.origin;
    const fullUrl = `${baseUrl}/list-rma?${order?.rma_id}`;

    // Check if the Clipboard API is available
    if (navigator.clipboard) {
      // Clipboard API is available, use it
      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          console.log("Link copied to clipboard");
          toast.success("Link copied to clipboard");
        })
        .catch((error) => {
          console.error("Failed to copy: ", error);
        });
    } else {
      // Fallback: Use a temporary textarea to copy text for browsers that do not support Clipboard API
      const textarea = document.createElement("textarea");
      textarea.value = fullUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      toast.success("Link copied to clipboard");
    }
  };

  const totalNotes = order?.section.reduce((acc, section) => {
    return acc + section.notes.length;
  }, 0);

  const handleModalClose = () => {
    setShow({ show: false });
    navigate("/list-order-lifecycle");
  };

  return (
    <>
      <Offcanvas
        name="Detail"
        show={show}
        // onHide={handleClose}
        // onHide={() => setShow({ show: false })}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="flex_profit_row">
              {/* <p className="mb-0">
                <span className="profit_est">Est. Profit:</span> $
                {(() => {
                  const after = Number(order?.total_cost_after_margin);
                  const before = Number(order?.total_cost_before_margin);
                  const profit = after - before;
                  const percentage = after !== 0 ? (profit / after) * 100 : 0;
                  return `${profit.toFixed(2)} (${percentage.toFixed(0)}%)`;
                })()}
              </p> */}

              <p className="mb-0">
                <span className="profit_est">Total Cost:</span> $
                {Number(order?.total_cost_after_margin)}
              </p>
            </div>
            <div className="flex_profit_row">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Edit</Tooltip>}
              >
                <span onClick={() => navigate(`/edit-rma/${order?.rma_id}`)}>
                  <IconEdit />
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Copy URL</Tooltip>}
              >
                <span onClick={handleShareClick}>
                  <IconShare />
                </span>
              </OverlayTrigger>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="head_title">
            <h2>RMA ID: {order?.rma_id}</h2>
            <div className="status_dropdown" style={{ position: "relative" }}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                  backgroundColor: selected.color,
                }}
                disabled={order?.status === "CANCELLED"}
              >
                {selected.label} <IconChevronDown />
              </button>
              {isOpen && (
                <div className="status_dropdown_select">
                  {statusOptions
                    .filter((option) => option.value !== selected.value)
                    .map((option) => (
                      <div
                        className="status_options"
                        key={option.value}
                        onClick={() =>
                          openModal(order?.rma_id, option.value, order.status)
                        }
                        style={{
                          backgroundColor: option.color + "20",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "33")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "20")
                        }
                      >
                        {option.label}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
          <div className="head_mini_details">
            <div className="flex_profit_row life_rows">
              <div className="life_head">
                <p className="mb-0">
                  <b className="profit_est icon_life_next">
                    <IconTruckDelivery stroke={1} />
                  </b>
                  <div>
                    <b className="profit_est">RMA Type: </b>
                    <span className="d-block">{order?.rma_type || "N/A"}</span>
                  </div>
                </p>
              </div>
              <div className="life_head">
                <p className="mb-0">
                  <b className="profit_est icon_life_next">
                    <IconChecklist stroke={1} />
                  </b>
                  <div>
                    <p className="mb-0">
                      <b className="profit_est icon_life_next">
                        Tracking Number:
                      </b>
                      {order?.tracking_number || "N/A"}
                    </p>
                    <p className="mb-0">
                      <b className="profit_est">Manufacturer Rma ID: </b>
                      {order?.manufacturer_id || "N/A"}
                    </p>
                  </div>
                </p>
              </div>
            </div>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> Customer Name
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.rmaKo?.name || "-"}</b>
              </Col>{" "}
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.rmaKo?.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                {order?.rmaKo?.email ? (
                  <span
                    onClick={(e) => {
                      setIsEmaillOpen({
                        title: "Contracting Officer's",
                        toName: order?.rmaKo?.name,
                        show: true,
                        ORDERID: order.rma_id,
                        toEmail: order?.rmaKo?.email,
                        Quote_No: order?.rma_id,
                        defaultSubject: `${order?.rma_id}----(RMA)`,
                        skuData: order?.RmaProducts,
                        row: order,
                      });
                    }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{order?.rmaKo.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.rmaKo?.address || "-"}</b>
              </Col>
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> Shipper Name
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.rmaShipping?.name || "-"}</b>
              </Col>{" "}
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.rmaShipping?.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                {order?.rmaShipping?.email ? (
                  <span
                    onClick={(e) => {
                      setIsEmaillOpen({
                        title: "Customer Details",
                        toName: order?.rmaShipping?.name,
                        show: true,
                        ORDERID: order.rma_id,
                        toEmail: order?.rmaShipping?.email,
                        Quote_No: order?.rma_id,
                        defaultSubject: `${order?.rma_id}----(RMA)`,
                        skuData: order?.RmaProducts,
                        row: order,
                      });
                    }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{order?.rmaShipping?.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{order?.rmaShipping?.address || "-"}</b>
              </Col>
            </Row>
          </div>

          <div className="attetchment_row">
            <p>
              <IconPaperclip stroke={1} width={20} /> Attachments{" "}
              <span>({order?.Attachments?.length})</span>
            </p>
            <div className="carousel-container">
              {order?.Attachments && order?.Attachments?.length > 0 ? (
                <>
                  <Swiper
                    slidesPerView={3}
                    spaceBetween={15}
                    loop={true}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    {order.Attachments?.map((item, index) => {
                      const fileExtension = item.original_name
                        .split(".")
                        .pop()
                        .toLowerCase();

                      let fileIcon;
                      if (fileExtension === "pdf") {
                        fileIcon = (
                          <IconFileTypePdf
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#D63939" }}
                          />
                        );
                      } else if (
                        [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "bmp",
                          "svg",
                          "webp",
                        ].includes(fileExtension)
                      ) {
                        fileIcon = (
                          <IconPhoto
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#AE3EC9" }}
                          />
                        );
                      } else {
                        fileIcon = (
                          <IconFileTypeDoc
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#4299E1" }}
                          />
                        );
                      }
                      return (
                        <SwiperSlide key={index} className="mySwiper">
                          <div className="card">
                            {item.type === "LINK" ? (
                              <a
                                href={item?.file_name}
                                target="_blank"
                                className="attetch_flex"
                              >
                                <IconLink
                                  stroke={1}
                                  width={45}
                                  height={45}
                                  style={{ color: "#4299E1" }}
                                />
                                <div className="attetch_info">
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span>LINK</span>
                                  </p>
                                </div>
                              </a>
                            ) : (
                              <div className="attetch_flex">
                                <div>{fileIcon}</div>
                                <div
                                  className="attetch_info"
                                  // onClick={(e) => {
                                  //   downloadImage(e, item.file_name);
                                  // }}
                                >
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span
                                      onClick={(e) => {
                                        downloadImage(e, item);
                                      }}
                                    >
                                      Download
                                    </span>
                                    <a
                                      className="text-blue"
                                      href={`${IMG}uploads/attachments/${item.file_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Preview
                                    </a>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </>
              ) : (
                <p>No Attachments available</p>
              )}
            </div>
          </div>

          <div className="tabs_details">
            <Tabs
              defaultActiveKey="General"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="General" title={`General`}>
                <div className="full_details border-0 p-0">
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      <p className="d-flex align-items-center gap-1">
                        Purchase Order:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{order?.purchase_order || "N/A"}</b>
                    </Col>{" "}
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      <p className="d-flex align-items-center gap-1">
                        Initial Cause:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{order?.initial_cause || "N/A"}</b>
                    </Col>{" "}
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Organization/Agency Name:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{order?.organization_name || "N/A"}</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={12} md={12}>
                      {" "}
                      <p>
                        <b className="d-block" style={{ color: "#000" }}>
                          RMA Description:{" "}
                        </b>
                        {order?.brief || "N/A"}
                      </p>
                    </Col>{" "}
                  </Row>
                </div>
              </Tab>
              <Tab
                eventKey="Products"
                title={
                  <>
                    Products{" "}
                    <span className="badge bg-indigo-lt">
                      {order?.RmaProducts?.length}
                    </span>
                  </>
                }
              >
                <Row>
                  {order?.RmaProducts?.map((product) => (
                    <Col md={12} key={product.id}>
                      <Card className="status_item_card w-100">
                        <Card.Body>
                          <div className="rfq_card_row">
                            <div className="rfq_item_card">
                              <div className="value_card">Vendor Name</div>
                              <p className="label_card">
                                {product.Vendor.display_name || "N/A"}
                              </p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">SKU ID</div>
                              <p className="label_card">
                                {product.sku_id || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="rfq_card_row">
                            {/* <div className="rfq_item_card">
                              <div className="value_card">Aspetto Cost</div>
                              <p className="label_card">
                                $
                                {product.aspetto_price
                                  ? product.aspetto_price
                                  : "N/A"}
                              </p>
                            </div> */}
                            <div className="rfq_item_card">
                              <div className="value_card">Total Cost</div>
                              <p className="label_card">
                                $
                                {product.total_price
                                  ? product.total_price
                                  : "N/A"}
                              </p>
                            </div>
                            <div className="rfq_item_card">
                              <div className="value_card">
                                Product Description
                              </div>
                              <p className="label_card mb-0">
                                {product.description ||
                                  "No description available"}
                              </p>
                            </div>
                          </div>
                          {/* <div className="rfq_card_row mb-0">
                            <div className="rfq_item_card">
                              <div className="value_card">
                                Product Description
                              </div>
                              <p className="label_card mb-0">
                                {product.description ||
                                  "No description available"}
                              </p>
                            </div>
                          </div> */}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Tab>
              <Tab
                eventKey="Notes"
                title={
                  <>
                    Notes{" "}
                    <span className="badge bg-indigo-lt">
                      {/* {opportunity.RfqNotes.length} */}
                      {totalNotes}
                    </span>
                  </>
                }
              >
                {order?.section?.length === 0 ? (
                  <div className="data_not_available text-center pb-4">
                    <Lottie animationData={notfoundData} />{" "}
                    <p>No notes available</p>
                  </div>
                ) : (
                  order?.section?.map((section) => (
                    <div key={section.id}>
                      {section.notes.length > 0
                        ? section.notes.map((note) => (
                            <Card
                              className="status_item_card w-100"
                              key={note.id}
                            >
                              <Card.Body>
                                <div className="flex_note_head mb-1">
                                  <span className="badge bg-indigo-lt">
                                    {section.name.charAt(0).toUpperCase() +
                                      section.name.slice(1)}
                                    .
                                  </span>
                                  <div className="note_info_time">
                                    <span className="note_user">
                                      <IconUserCircle /> {note.User.first_name}{" "}
                                      {note.User.last_name}
                                    </span>
                                    <p className="note_user mb-0">
                                      <IconClockHour3 />{" "}
                                      {moment(note.createdAt).format(
                                        "MM/DD/YYYY hh:mm A",
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <p className="mb-0">{note.note}</p>
                              </Card.Body>
                            </Card>
                          ))
                        : null}
                    </div>
                  ))
                )}
              </Tab>
            </Tabs>
          </div>
          {isEmaillOpen.show && (
            <RmaKOorCustomerEmailDialog
              pagetitle={isEmaillOpen.title}
              toEmail={isEmaillOpen.toEmail}
              toName={isEmaillOpen.toName}
              ORDERID={isEmaillOpen.ORDERID}
              show={isEmaillOpen.show}
              skuData={isEmaillOpen.skuData}
              row={isEmaillOpen.row}
              defaultSubject={isEmaillOpen.defaultSubject}
              Quote_No={isEmaillOpen.Quote_No}
              setShow={setIsEmaillOpen}
              setIsSuccsessModalOpen={setIsSuccsessModalOpen}
            />
          )}
        </Offcanvas.Body>
      </Offcanvas>
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          setIsOpen(false);
        }}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen(
            { ...isSuccsessModalOpen, show: false },
            // navigate("/dashboard")
          )
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />
    </>
  );
}

export default View_DetailsRma;
